import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const testUserNamesCacheKey = "/internal_user_groups/test_user_names" as const;
export const internalUserGroupsCacheKey = "/internal_user_groups/internal_user_groups_data" as const;
export const appSettingsInternalUserGroupsDeleteTestUserCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/:internal_user_group_id",
  "/internal_user_groups/:internal_user_group_id/test_users_v2",
];
